import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import CountUp from "react-countup"
import Flickity from "react-flickity-component"
import VisibilitySensor from "react-visibility-sensor"
import Header from "../components/Header"
import Layout from "../components/Layout"
import { btn, btnDark, btnPrimary } from "../ds/button.module.css"
import { WhiteArrowRight } from "../ds/Shapes"
import attendees_poster from "../images/attendees-poster-creation.png"
import logo5 from "../images/client-logos/latest/1.png"
import logo6 from "../images/client-logos/latest/2.png"
import logo7 from "../images/client-logos/latest/3.png"
import logo8 from "../images/client-logos/latest/4.png"
import logo1 from "../images/client-logos/latest/5.png"
import logo2 from "../images/client-logos/latest/6.png"
import logo3 from "../images/client-logos/latest/7.png"
import logo4 from "../images/client-logos/latest/8.png"
import grid from "../images/partners/grid.png"
import poster from "../images/tailored-posters.png"
import useWindowDimensions from "../utils/useWindowDimensions"

import RolesSlider from "../components/RolesSlider"
import { VideoPlayer } from "../components/VideoPlayer"
import avatar1 from "../images/avatar-01.png"
import avatar2 from "../images/avatar-02.png"
import avatar3 from "../images/avatar-03.png"
import avatar4 from "../images/avatar-04.png"
import avatar5 from "../images/avatar-05.png"
import g2Banner from "../images/g2-banner.png"
import gitexBanner from "../images/case-study/gitex-global/gitex_banner.png"
import smPoster3 from "../images/sm-poster-03.png"
import smPoster1 from "../images/sm-poster01.png"
import smPoster2 from "../images/sm-poster02.png"
import poster1 from "../images/sm-poster1.png"
import poster10 from "../images/sm-poster10.png"
import poster11 from "../images/sm-poster11.png"
import poster2 from "../images/sm-poster2.png"
import poster3 from "../images/sm-poster3.png"
import poster4 from "../images/sm-poster4.png"
import poster5 from "../images/sm-poster5.png"
import poster6 from "../images/sm-poster6.png"
import poster7 from "../images/sm-poster7.png"
import poster8 from "../images/sm-poster8.png"
import poster9 from "../images/sm-poster9.png"
import ai_video from "../videos/ai-caption.mp4"
import gitex_video from "../videos/gitex.mp4"
import gitex_video_thumb from "../images/thumbnails/gitex-video.png"
import widget_banner from "../videos/poster-widget.mp4"

import { FaqAccordionSection } from "../components/FaqSection"
import IntegrationGuideStripe from "../components/integrations/IntegrationGuideStripe"
import PremagicNewsSection from "../components/PremagicNews"
const clientLogos = [
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
]

const posters = [
  // { id: 1, src: poster1, alt: "Poster 1" },a
  { id: 2, src: poster2, alt: "Poster 2" },
  { id: 3, src: poster3, alt: "Poster 3" },
  { id: 4, src: poster4, alt: "Poster 4" },
  { id: 5, src: poster5, alt: "Poster 5" },
  { id: 6, src: poster6, alt: "Poster 6" },
  { id: 7, src: poster7, alt: "Poster 7" },
  { id: 8, src: poster8, alt: "Poster 8" },
  { id: 9, src: poster9, alt: "Poster 9" },
  { id: 10, src: poster10, alt: "Poster 10" },
  { id: 11, src: poster11, alt: "Poster 11" },
]

export default function Index() {
  const { width } = useWindowDimensions()
  const isMobileUp = width >= 768
  const containerWidth = isMobileUp ? "1080px" : "100%"

  const flickityOptions = {
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    autoPlay: 4000,
    friction: 0.2,
    selectedAttraction: 0.01,
    pauseAutoPlayOnHover: false,
    contain: true,
    cellAlign: "left",
  }
  const caseStudySliderOptions = {
    autoPlay: false,
    wrapAround: false,
    selectedAttraction: 0.01,
    friction: 0.2,
    cellAlign: "left",
    contain: true,
    pageDots: false,
    pauseAutoPlayOnHover: false,
    prevNextButtons: true,
  }

  const clientLogosOptions = {
    autoPlay: !isMobileUp,
    wrapAround: true,
    selectedAttraction: 0.01,
    friction: 0.2,
    cellAlign: "left",
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    pauseAutoPlayOnHover: false,
  }

  // const posters = [
  //   { id: 1, src: poster1, alt: "Poster 1" },
  //   { id: 2, src: poster2, alt: "Poster 2" },
  //   { id: 3, src: poster3, alt: "Poster 3" },
  //   { id: 4, src: poster4, alt: "Poster 4" },
  //   { id: 5, src: poster5, alt: "Poster 5" },
  //   { id: 6, src: poster6, alt: "Poster 6" },
  //   { id: 7, src: poster7, alt: "Poster 7" },
  //   { id: 8, src: poster8, alt: "Poster 8" },
  //   { id: 9, src: poster9, alt: "Poster 9" },
  //   { id: 10, src: poster10, alt: "Poster 10" },
  //   { id: 11, src: poster11, alt: "Poster 11" },
  // ]

  const CASE_STUDIES = [
    {
      id: 1,
      imageUrl: gitexBanner,
      thumbnail: gitex_video_thumb,
      video: gitex_video,
      title: "It’s everything that a modern event marketer would need!",
      quote:
        "We switched to Premagic because our previous supplier’s technology was outdated and no longer met our needs. Premagic feels modern and creative — I especially like how it’s very Canva-like, offering plenty of options for customization and creativity.",
      name: "Shreya Shyamsunder",
      role: "Marketing Executive",
      org: "Dubai World Trade Centre",
      ctaRoute: "/case-study/gitex-global",
      stats: [
        { value: "16,192", label: "Advocates" },
        { value: "44,374", label: "Referrals" },
        { value: "30%", label: "Conversion rate" },
      ],
      bgColor: "#E6DFFF",
    },
    {
      id: 2,
      imageUrl: g2Banner,
      title:
        "G2 Live saw 4x more registrations by integrating marketing posters.",
      quote:
        "I was very impressed by Premagic’s event tech. Across the event, we saw many of these posters being shared online, and we’re confident that it played a pivotal role in driving our registration numbers for the event.",
      name: "Kevin Fernandes",
      role: "New Business Acquisition Manager",
      org: "G2 APAC",
      ctaRoute: "/case-study/g2-live",
      stats: [
        { value: "103", label: "Advocates" },
        { value: "796", label: "Referrals" },
        { value: "4X", label: "Registrations" },
      ],
      bgColor: "#ffccc5",
    },
  ]

  return (
    <Layout
      title="Create Event Posters Instantly - AI Poster Generator"
      description="Create personalized, shareable posters in seconds with AI. Custom designs for maximum social media engagement."
      keywords={[
        "AI poster generator, event poster creator, instant poster design, personalized event posters, shareable poster maker, automated poster creation, AI marketing visuals, event poster tool, social media event posters, custom event designs, marketing poster automation, AI graphic design events, promotional poster generator, digital event posters, branded poster creation",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Marketing Posters", url: "/create-event-marketing-posters/" },
      ]}
    >
      <div className="">
        <div className="" style={{ backgroundColor: "#7251F4" }}>
          <Header isWhiteLogo />
        </div>

        <section className="py-10" style={{ backgroundColor: "#7251F4" }}>
          <div className="px-5 md:px-0 mx-auto md:w-[1080px]">
            <div className="md:flex items-center md:h-[500px] h-full">
              <div className="md:w-2/3 flex flex-col items-center md:items-start justify-center md:text-left text-center">
                {/* <h1 className="text-3xl md:text-5xl font-bold mb-4 text-white"><span style={{ color: '#61F2C2' }}>DOUBLE</span> YOUR <br />ATTENDEES</h1> */}
                <h1 className="text-3xl md:text-5xl mb-4 text-white !leading-[1.3em]">
                  <b>
                    4x your registration <br />
                  </b>
                  with custom event <br /> marketing posters
                </h1>
                <p className="text-white text-md md:w-2/3 w-full mx-auto md:mx-0 ">
                  Let your attendees spread the word with personalized,
                  ready-to-share event posters.
                </p>

                <Link
                  to="https://premagic.com/request-a-demo/?utm_source=website&utm_medium=product&utm_id=Event+Poster"
                  className={`${btn} ${btnDark} text-xs mt-4 relative w-max group`}
                >
                  <span className="mr-4 ml-2">Get a Demo</span>
                  <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
                </Link>
                <section className="mt-10 mb-10 md:mb-0 hidden md:block">
                  <div className="grid max-w-2xl grid-cols-1 gap-4 md:grid-cols-3">
                    {/* Box 1 */}
                    <div
                      className="rounded-2xl bg-[#1c0c4b]/60 px-4 md:px-8 py-4 md:py-6 text-white text-center shadow-lg shadow-black/20 animate-fadeUp opacity-0"
                      style={{ animationDelay: "0.1s" }}
                    >
                      <div className="text-xl md:text-3xl font-semibold leading-none">
                        4x
                      </div>
                      <p className="mt-2 text-xs md:text-base text-white">
                        registrations
                      </p>
                    </div>

                    {/* Box 2 */}
                    <div
                      className="rounded-2xl bg-[#1c0c4b]/60 px-4 md:px-8 py-4 md:py-6 text-white text-center shadow-lg shadow-black/20 animate-fadeUp opacity-0"
                      style={{ animationDelay: "0.3s" }}
                    >
                      <div className="text-xl md:text-3xl font-semibold leading-none">
                        2.5x
                      </div>
                      <p className="mt-2 text-xs md:text-base text-white">
                        more referrals
                      </p>
                    </div>

                    {/* Box 3 */}
                    <div
                      className="rounded-2xl bg-[#1c0c4b]/60 px-4 md:px-8 py-4 md:py-6 text-white text-center shadow-lg shadow-black/20 animate-fadeUp opacity-0"
                      style={{ animationDelay: "0.5s" }}
                    >
                      <div className="text-xl md:text-3xl font-semibold leading-none">
                        30%
                      </div>
                      <p className="mt-2 text-xs md:text-base text-white">
                        conversion rate
                      </p>
                    </div>
                  </div>
                </section>
              </div>
              <div className="md:w-1/3 md:ml-0 relative h-full">
                <div className="md:absolute -right-[100px] -top-[50px] md:w-[550px]">
                  <StaticImage
                    src="../images/advocacy_poster_hero.png"
                    alt="ai-event-poster-creator-tool-hero"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {isMobileUp ? (
          <div>
            <ul className="flex items-center justify-center">
              {clientLogos?.slice(0, 8).map((logo, idx) => (
                <li>
                  <img
                    key={`logo-${idx}`}
                    src={logo}
                    alt={`Client Logo ${idx + 1}`}
                    className="w-24 h-24 object-contain mx-6"
                  />
                </li>
              ))}
            </ul>
          </div>
        ) : (
          <Flickity
            className="carousel w-full max-w-6xl mx-auto pl-4 border-none outline-none"
            elementType="div"
            options={clientLogosOptions}
            disableImagesLoaded={false}
            reloadOnUpdate
            static
          >
            {clientLogos?.map((logo, idx) => (
              <img
                key={`logo-${idx}`}
                src={logo}
                alt={`Client Logo ${idx + 1}`}
                className="w-24 h-24 object-contain mx-6"
              />
            ))}
          </Flickity>
        )}

        <section className="">
          <Flickity
            className="carousel md:h-[400px] h-auto outline-none border-none pl-4"
            elementType="div"
            options={flickityOptions}
            disableImagesLoaded={false}
            reloadOnUpdate
          >
            {posters.map((poster) => (
              <div
                key={poster.id}
                className="
                    w-1/2 md:w-auto
                    h-60 md:h-96
                    mx-2
                    overflow-hidden
                  "
              >
                <img
                  src={poster.src}
                  alt={poster.alt}
                  className="w-full h-full object-cover rounded-xl"
                />
              </div>
            ))}
          </Flickity>
        </section>

        <RolesSlider />

        <section className="bg-white py-16 px-6 md:px-12">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-2xl md:text-4xl font-bold mb-4 text-black">
              How do event marketing posters boost attendee engagement?
            </h2>
            <p className="text-gray-500 text-base md:text-lg max-w-3xl mx-auto mb-12">
              Set up personalized "I'm attending" posters once. Then sit back
              and watch your attendees turn your event into the talk of the
              town, one share at a time.
            </p>
          </div>
          <div className="mt-6 max-w-4xl mx-auto">
            <VideoPlayer url="https://youtu.be/tNNJ1gYnXjA?si=MdLwT-p4H8TuaAv8" />
          </div>
        </section>

        <section className="pb-20 px-4 text-center bg-white">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-black">
            Your attendees want to brag. Let them!
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-2xl mx-auto mb-12">
            This is event referral marketing that works. When attendees share
            personalized event posters, their networks pay attention. And you
            get organic reach that paid ads can't buy. Plus, smart referral
            tracking that shows you exactly who drove registrations
          </p>

          <div className="bg-[#F8F9FB] shadow-md rounded-2xl max-w-5xl mx-auto px-6 py-8 md:px-10 md:py-10 text-left">
            <h3 className="text-xl font-semibold mb-6">
              Event Advocates (16.2k){" "}
            </h3>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {[
                {
                  label: "Advocates",
                  value: "16,192",
                  valueClass: "text-[#2E1A84]",
                },
                {
                  label: "Potential Reach",
                  value: "5,969,404",
                  valueClass: "text-[#2E1A84]",
                },
                {
                  label: "Referrals",
                  value: "44,108",
                  valueClass: "text-[#2E1A84]",
                },
                {
                  label: "ROI",
                  value: "$204,158",
                  valueClass: "text-[#00A671]",
                },
              ].map((stat, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-4 flex flex-col gap-1 text-center shadow-sm"
                >
                  <span className="text-sm text-gray-500">{stat.label}</span>
                  <span
                    className={`text-2xl font-bold tracking-tight ${stat.valueClass}`}
                  >
                    {stat.value.startsWith("$") && "$"}
                    <CountUp end={Number(stat.value.replace(/[^0-9]/g, ""))}>
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <span ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                  </span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-white pb-16 px-6 md:px-12">
          <div className="max-w-5xl mx-auto rounded-2xl border border-[#E6DFFF] bg-gradient-to-br from-[#F7F5FF] to-white px-6 py-8 md:px-10 md:py-10 md:flex md:items-center md:justify-between gap-8">
            <div className="md:flex-1">
              <span className="inline-block px-3 py-1 rounded-full bg-[#E6DFFF] text-[#4F3DBE] text-[10px] font-bold uppercase tracking-wider mb-3">
                Strategy Guide · 10 min read
              </span>
              <h3 className="text-xl md:text-2xl font-bold text-black mb-2">
                Want the playbook behind these numbers?
              </h3>
              <p className="text-gray-600 text-sm md:text-base max-w-2xl">
                Read the Event Advocacy Playbook — a 4-phase guide to turning
                attendees, speakers, and exhibitors into a volunteer marketing
                army using personalized posters.
              </p>
            </div>
            <div className="mt-6 md:mt-0 md:ml-6 shrink-0">
              <Link
                to="/reports/event-advocacy-playbook/"
                className={`${btn} ${btnPrimary} text-xs w-max group flex items-center`}
              >
                <span className="mr-3">Read the Playbook</span>
                <WhiteArrowRight className="transition-transform duration-300 group-hover:translate-x-2" />
              </Link>
            </div>
          </div>
        </section>

        <section className="py-8 px-10">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-black text-center mb-4">
            Real events. Real people. Real results
          </h2>

          <div className="py-10">
            <Flickity
              className="carousel mt-4 h-auto md:pl-14 border-none outline-none"
              elementType="div"
              options={caseStudySliderOptions}
              disableImagesLoaded={false}
              reloadOnUpdate
            >
              {CASE_STUDIES.map((caseStudy, idx) => (
                <div
                  className="card flex flex-col
             xl:flex-row
             px-6 py-6 lg:px-8
             w-full lg:w-[70%]
             h-[635px] md:h-auto lg:min-h-[460px]
             rounded-2xl mr-6"
                  style={{ background: caseStudy.bgColor }}
                >
                  {/* LEFT */}
                  <div className="w-full lg:w-[65%] lg:w-full 2xl:w-[50%] md:mr-10">
                    {/* Media */}
                    <div className="overflow-hidden rounded-xl">
                      {caseStudy.video ? (
                        <VideoPlayer
                          url={caseStudy.video}
                          thumbnail={caseStudy.thumbnail}
                          type="controls"
                        />
                      ) : (
                        <img
                          src={caseStudy.imageUrl}
                          alt="Event case study banner"
                          className="w-full h-auto object-cover rounded-xl"
                        />
                      )}
                    </div>

                    {/* Stats – desktop only */}
                    {isMobileUp && (
                      <div className="mt-4 mb-4 lg:mb-0">
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                          {caseStudy?.stats.map((card, idx) => (
                            <div
                              key={idx}
                              className="rounded-xl bg-white px-2 py-4 text-[#1F0F61]
                         text-center shadow-lg shadow-black/20"
                            >
                              <div className="text-xl font-semibold mb-2">
                                {card.value}
                              </div>
                              <p className="text-xs text-[#7251F4]">
                                {card.label}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* RIGHT */}
                  <div className="flex flex-col gap-6 mt-6 md:mt-0 lg:w-2/3 w-full">
                    {/* Content */}
                    <div>
                      <h4 className="text-lg md:text-2xl font-bold text-black mb-4">
                        {caseStudy?.title}
                      </h4>
                      <p className="text-xs md:text-[14px] leading-6">
                        "{caseStudy?.quote}"
                      </p>
                    </div>

                    {/* Author + CTA */}
                    <div className="">
                      <h4 className="text-black font-bold">
                        {caseStudy?.name}
                      </h4>
                      <span className="text-xs md:text-sm block">
                        {caseStudy?.role} <br /> {caseStudy?.org}
                      </span>

                      <Link
                        to={caseStudy?.ctaRoute}
                        className={`${btn} ${btnPrimary} text-xs mt-4 w-max group flex items-center`}
                      >
                        <span className="mr-3">Read the Case study</span>
                        <WhiteArrowRight className="transition-transform duration-300 group-hover:translate-x-2" />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </Flickity>
          </div>
        </section>

        <section className="bg-[#7251F4] relative overflow-hidden text-white pt-20 px-6 md:px-12">
          <img
            src={grid}
            alt="grid"
            className="h-full w-full absolute inset-0 z-4 object-cover"
          />
          <div className="max-w-6xl mx-auto grid md:grid-cols-2  gap-10 items-center relative z-[44] text-center">
            <div className="order-2 md:order-1 -mt-[85px] md:mt-0">
              <h2 className="text-2xl md:text-4xl font-bold leading-tight mb-6 text-white ">
                Customizable posters for all event stakeholders
              </h2>
              <p className="text-lg text-white/90 mb-8">
                Unique attendees deserve unique posters
                <br />
                <br />
                Create personalized posters for segmented campaigns- whether
                they’re attending, speaking, exhibiting, or more!
              </p>
              <Link
                to="https://premagic.com/request-a-demo/?utm_source=website&utm_medium=product&utm_id=Event+Poster"
                className={`${btn} ${btnPrimary} text-xs mt-4 mb-10 md:mb-0 relative w-max group`}
              >
                <span className="mr-4 ml-2">See it in Action</span>
                <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
              </Link>
            </div>

            <div className="relative w-full md:w-[660px] order-1 md:order-2">
              <img
                src={poster}
                alt="Tailored Posters"
                className="relative z-10 w-full max-w-xl mx-auto"
              />
            </div>
          </div>
        </section>
        <section className="bg-white md:bg-[#F7F5FF] pt-24 md:pb-8 mt:pt-20 px-6 md:px-12 relative">
          <h2 className="text-2xl md:text-4xl font-extrabold text-black mb-2 text-center mx-auto">
            Custom branded event posters {isMobileUp && <br />} that match your
            brand
          </h2>
          <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-10 items-center justify-between">
            {/* Left content */}
            <div className="order-2 md:order-1  md:pb-0 -mt-12 md:mt-0">
              <p className="text-gray-700 text-base md:text-md mb-6">
                Whether you want complete creative control or prefer a
                ready-to-go poster design library to perfectly reflect your
                brand's identity
              </p>

              <ul className="list-disc pl-5 space-y-2 text-gray-800 mb-8 text-md">
                <li>
                  <strong className="text-black">
                    2,500+ professional fonts,
                  </strong>{" "}
                  unique design elements, and extensive customization options .
                </li>
                <li>
                  <strong className="text-black">
                    Multiple layout templates,
                  </strong>{" "}
                  optimized for different event stakeholders.
                </li>
                <li>
                  <strong className="text-black">
                    Pre-designed inspiration library,
                  </strong>{" "}
                  when you need ideas fast
                </li>
                <li>
                  <strong className="text-black">Playful AI avatars ,</strong>{" "}
                  that bring a whimsical twist to every attendee’s feed.
                </li>
              </ul>
              <Link
                to="https://premagic.com/request-a-demo/?utm_source=website&utm_medium=product&utm_id=Event+Poster"
                className={`${btn} ${btnPrimary} text-xs mt-4 mb-10 md:mb-0 relative w-max group`}
              >
                <span className="mr-4 ml-2">Get a Demo</span>
                <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
              </Link>
            </div>

            {/* Right side image */}
            <div className="md:w-[770px] w-full] order-1 md:order-2">
              <img
                src={attendees_poster}
                alt="Poster Customization"
                className="w-full max-w-xl "
              />
            </div>
          </div>
        </section>
        <section className="bg-white md:bg-white pt-20 pb-10 md:pb-0 px-6 md:px-12 text-center bg-white">
          <div className="max-w-4xl mx-auto md:pb-16">
            <h2 className="text-2xl md:text-4xl font-extrabold text-black mb-4">
              One-tap event promotion on every platform
            </h2>
            <span className="block mb-4 text-[#5E5E5E]">
              Sharing made effortless for every attendee.
            </span>
            {!isMobileUp && (
              <div className="flex justify-center overflow-hidden">
                <video
                  src={ai_video}
                  loop
                  muted
                  autoPlay
                  className="border-0 outline-none focus:outline-none shadow-none relative -right-[2px] -bottom-[2px]"
                  playsInline
                  disablePictureInPicture
                ></video>
              </div>
            )}
            <p className="text-black font-semibold mb-4 text-base md:text-lg">
              No copying. No typing. No overthinking.
            </p>
            <p className="text-gray-600 text-base w-[90%] mx-auto">
              Personalized and customizable AI content for every advocate,
              optimized for multiple social platforms, shareable with a single
              click. More reach, less work.
            </p>
            <Link
              to="https://premagic.com/request-a-demo/?utm_source=website&utm_medium=product&utm_id=Event+Poster"
              className={`${btn} ${btnPrimary} text-xs mt-4 mb-10 md:mb-0 relative w-max group`}
            >
              <span className="mr-4 ml-2">Get a Demo</span>
              <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
            </Link>
          </div>
          {/* Image Placeholder */}
          {isMobileUp && (
            <div className="flex justify-center w-1/2 mx-auto border-0 shadow-none overflow-hidden">
              {/* <StaticImage
                src="../images/share-section-graphic.png"
                alt="ai-event-poster-creator-tool-effortless-mobile"
                className="w-full max-w-3xl"
              /> */}
              <video
                src={ai_video}
                loop
                muted
                autoPlay
                className="border-0 outline-none focus:outline-none shadow-none relative -right-[2px] -bottom-[2px]"
              ></video>
            </div>
          )}
        </section>
        <section className="bg-[#f5edf9] md:py-14 py-6">
          <div className="mx-auto flex max-w-6xl flex-col gap-10 px-4 py-16 md:flex-row md:items-center md:px-6 lg:px-8">
            <div className="md:w-1/2">
              <h2 className="text-2xl text-center md:text-left font-extrabold leading-tight text-[#15121d] md:text-4xl">
                See exactly who's driving
                <br />
                event registrations
              </h2>

              <p className="mt-4 text-base text-[#4b455b] text-center md:text-left">
                No complicated dashboards. Just a live leaderboard to track what
                really matters.
              </p>

              <ul className="mt-5 space-y-2 text-sm text-[#4b455b] md:text-base list-disc list-inside mx-auto w-fit mx-auto md:mx-0">
                <li>Track shares across all social platforms</li>
                <li>See which posters drive the most clicks</li>
                <li>Identify your top event promoters</li>
                <li>Measure ROI on social referral marketing</li>
                <li>Export data for your marketing reports</li>
              </ul>

              <div className="mt-8 hidden md:block">
                <Link
                  to="https://premagic.com/request-a-demo/?utm_source=website&utm_medium=product&utm_id=Event+Poster"
                  className={`${btn} ${btnPrimary} text-xs mt-4 mb-10 md:mb-0 relative w-max group`}
                >
                  <span className="mr-4 ml-2">Get a Demo</span>
                  <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
                </Link>
              </div>
            </div>

            <div className="relative md:w-1/2   flex justify-center scale-[0.8]">
              <div className="relative w-full max-w-3xl rounded-xl bg-white shadow-[0_24px_70px_rgba(0,0,0,0.15)] p-4 md:p-5 mt-[100px] md:mt-0">
                <div className="absolute -top-40 md:-top-40 left-1/2 w-[90%] max-w-sm -translate-x-1/2 rounded-2xl bg-white shadow-[0_18px_50px_rgba(0,0,0,0.15)] p-4 border border-[#CBBEFF]">
                  <p className="text-xs font-medium text-[#7b7396] text-semibold">
                    Attendee
                  </p>
                  <p className="text-[11px] text-[#a39abf]">
                    2.85 Referrals per advocate
                  </p>

                  <div className="mt-4 flex items-end justify-between">
                    <div>
                      <p className="text-2xl font-bold text-[#15121d]">
                        <CountUp end={Number("12,968".replace(/[^0-9]/g, ""))}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>
                      </p>
                      <p className="text-xs text-[#a39abf]">Advocates</p>
                    </div>
                    <div>
                      <p className="text-2xl font-bold text-[#15121d]">
                        <CountUp end={Number("36,965".replace(/[^0-9]/g, ""))}>
                          {({ countUpRef, start }) => (
                            <VisibilitySensor onChange={start} delayedCall>
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>
                      </p>
                      <p className="text-xs text-[#a39abf] text-right">
                        Referrals
                      </p>
                    </div>
                  </div>

                  <div className="mt-3 flex -space-x-2">
                    {[avatar1, avatar2, avatar3, avatar4, avatar5].map(
                      (avatar, i) => (
                        <img
                          src={avatar}
                          alt="Event advocate avatar"
                          className="w-10 h-10 rounded-full"
                        />
                      )
                    )}
                  </div>
                </div>

                <div className="flex gap-3">
                  <div className="flex-1 overflow-hidden rounded-lg border border-[#efe7ff] bg-white">
                    <div className="h-auto bg-gradient-to-br from-[#ff7b5f] via-[#ff9c5f] to-[#ffcf6c]">
                      <img
                        src={smPoster1}
                        alt="Event marketing poster variant A preview"
                        width="300"
                        height="300"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-3">
                      <p className="text-sm font-semibold text-[#15121d]">
                        Poster A
                      </p>
                      <p className="mt-1 text-[11px] text-[#9b93b5]">
                        2.75 Referrals per advocate
                      </p>
                      {isMobileUp && (
                        <div className="mt-3 flex justify-between text-xs">
                          <div>
                            <p className="font-semibold text-[#15121d] text-xs">
                              <CountUp
                                end={Number(
                                  Number("10,303".replace(/[^0-9]/g, ""))
                                )}
                              >
                                {({ countUpRef, start }) => (
                                  <VisibilitySensor
                                    onChange={start}
                                    delayedCall
                                  >
                                    <span ref={countUpRef} />
                                  </VisibilitySensor>
                                )}
                              </CountUp>
                            </p>
                            <p className="text-[#9b93b5] text-xs">Advocates</p>
                          </div>
                          <div>
                            <p className="font-semibold text-[#15121d] text-xs">
                              28,350
                            </p>
                            <p className="text-[#9b93b5] text-xs">Referrals</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex-1 overflow-hidden rounded-2xl border border-[#efe7ff] bg-white">
                    <div className="h-auto bg-gradient-to-br from-[#ff7b5f] via-[#ff9c5f] to-[#ffcf6c]">
                      <img
                        src={smPoster2}
                        alt="Event marketing poster variant B preview"
                        width="300"
                        height="300"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-3">
                      <p className="text-sm font-semibold text-[#15121d]">
                        Poster B
                      </p>
                      <p className="mt-1 text-[11px] text-[#9b93b5]">
                        3.36 Referrals per advocate
                      </p>
                      {isMobileUp && (
                        <div className="mt-3 flex justify-between text-xs">
                          <div>
                            <p className="font-semibold text-[#15121d] text-xs">
                              1,934
                            </p>
                            <p className="text-[#9b93b5] text-xs">Advocates</p>
                          </div>
                          <div>
                            <p className="font-semibold text-[#15121d] text-xs">
                              6,499
                            </p>
                            <p className="text-[#9b93b5] text-xs">Referrals</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="flex-1 overflow-hidden rounded-2xl border border-[#efe7ff] bg-white">
                    <div className="h-auto bg-gradient-to-br from-[#ff7b5f] via-[#ff9c5f] to-[#ffcf6c]">
                      <img
                        src={smPoster3}
                        alt="Event marketing poster variant C preview"
                        width="300"
                        height="300"
                        loading="lazy"
                      />
                    </div>
                    <div className="p-3">
                      <p className="text-sm font-semibold text-[#15121d]">
                        Poster C
                      </p>
                      <p className="mt-1 text-[11px] text-[#9b93b5]">
                        2.89 Referrals per advocate
                      </p>
                      {isMobileUp && (
                        <div className="mt-3 flex justify-between text-xs">
                          <div>
                            <p className="font-semibold text-[#15121d] text-xs">
                              734
                            </p>
                            <p className="text-[#9b93b5] text-xs">Advocates</p>
                          </div>
                          <div>
                            <p className="font-semibold text-[#15121d] text-xs">
                              2,116
                            </p>
                            <p className="text-[#9b93b5] text-xs">Referrals</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-8 block md:hidden text-center">
              <Link
                to="https://premagic.com/request-a-demo/?utm_source=website&utm_medium=product&utm_id=Event+Poster"
                className={`${btn} ${btnPrimary} text-xs`}
              >
                <span className="mr-4 ml-2">Get a Demo</span>
                <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
              </Link>
            </div>
          </div>
        </section>

        <section className="bg-white py-20">
          <div className="max-w-6xl mx-auto px-4 text-center">
            <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 leading-tight">
              Higher referrals with <br /> share-ready poster widgets
            </h2>

            <p className="mt-4 text-gray-500 text-sm md:text-lg">
              Turn every event page visit into a sharing opportunity.
            </p>

            <p className="mt-6 max-w-3xl mx-auto text-gray-700 text-base leading-relaxed">
              Embed our customizable poster widget on your registration page,
              emails, or event lobby and turn every registration into instant,
              personalized promotion.
            </p>

            <div className="mt-16 flex justify-center">
              <video
                src={widget_banner}
                className="rounded-xl md:max-w-3xl w-full px-2 md:px-0"
                autoPlay
                muted
                loop
                playsInline
                controls={false}
                preload="auto"
                disablePictureInPicture
              />
            </div>
          </div>
          {isMobileUp ? (
            <div className="mt-20 flex justify-center -mb-[80px]">
              <StaticImage
                src="../images/dashboard-ui-sm.png"
                alt="ai-event-poster-creator-tool-Leaderboard"
                className="w-full max-w-6xl rounded-t-xl shadow"
              />
            </div>
          ) : (
            <div className="mt-10 flex justify-center -mb-[80px]">
              <StaticImage
                src="../images/dashboard-ui-sm.png"
                alt="ai-event-poster-creator-tool-Leaderboard"
                className="w-full max-w-6xl rounded-t-xl shadow"
              />
            </div>
          )}
        </section>
        <section className="bg-[#7652FF] pt-20 md:pb-20 px-6 md:text-center text-white">
          <h2 className="text-2xl md:text-4xl font-bold mb-4 text-white">
            Ready to increase your event registrations?
          </h2>
          <p className="text-white/90 text-lg mb-4">
            Join leading event marketers who use personalized event posters to
            drive 4x {isMobileUp && <br />} more registrations through authentic
            social sharing.
          </p>
          <Link
            to="/request-a-demo/"
            className={`${btn} ${btnPrimary} text-xs mt-4 mb-10 md:mb-0 relative w-max group`}
          >
            <span className="mr-4 ml-2">Let's Grow</span>
            <WhiteArrowRight className="transition duration-300 ease-in-out group-hover:translate-x-2 mr-2" />
          </Link>
        </section>
        <IntegrationGuideStripe context="Drop the Quick Register and Poster Creator widgets into your existing registration flow." />
        <PremagicNewsSection />
        <FaqAccordionSection />
      </div>
    </Layout>
  )
}
